import walkWebp from "@/assets/gentle-walk.webp";
import walkJpg from "@/assets/gentle-walk.jpg";
import Picture from "@/components/ui/picture";

const items = [
  { label: "Walking", note: "A short, daily walk — even 10 minutes." },
  { label: "Real food", note: "Simple meals, mostly home-cooked." },
  { label: "Better sleep", note: "Earlier nights, gentler mornings." },
  { label: "Less stress", note: "Small pauses sprinkled through the day." },
];

const GentleApproach = () => (
  <section id="solution" className="bg-background py-20 sm:py-28">
    <div className="reading-column px-6">
      <h2 className="font-serif text-3xl text-foreground sm:text-4xl">A gentle approach</h2>
      <p className="mt-4 text-lg text-foreground/80">
        No pressure. Just small steps that fit into a real life.
      </p>

      <ul className="mt-10 divide-y divide-border">
        {items.map((it) => (
          <li key={it.label} className="flex items-baseline justify-between gap-6 py-5">
            <span className="font-serif text-xl text-foreground">{it.label}</span>
            <span className="text-right text-base text-foreground/70">{it.note}</span>
          </li>
        ))}
      </ul>

      <p className="mt-8 italic text-foreground/75">
        You don't have to do all of this at once.
      </p>

      <div className="mt-12 overflow-hidden rounded-[1.5rem]">
        <Picture
          webp={walkWebp}
          fallback={walkJpg}
          alt="A peaceful walk on a leafy path at golden hour"
          width={1280}
          height={896}
          loading="lazy"
          className="h-auto w-full object-cover"
        />

      </div>
    </div>
  </section>
);

export default GentleApproach;
